import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlockedVideoMassageComponent } from './blocked-video-massage/blocked-video-massage.component';
import { ButtonsComponent } from './buttons/buttons.component';
import { PageHeaderComponent } from './page-header/page-header.component';
import { VideoCardComponent } from './video-card/video-card.component';
import { SearchWithSelectComponent } from './search-with-select/search-with-select.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { SearchComponent } from './search/search.component';
import { SharedRoutingModule } from './shared-routing.module';
import { AdvertismentComponent } from './advertisment/advertisment.component';
import { VerifyCodeModalComponent } from './verify-code-modal/verify-code-modal.component';


@NgModule({
  declarations: [
    BlockedVideoMassageComponent,
    ButtonsComponent,
    PageHeaderComponent,
    VideoCardComponent,
    SearchWithSelectComponent,
    SearchComponent,
    AdvertismentComponent,
    VerifyCodeModalComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatIconModule,
    SharedRoutingModule,
    ReactiveFormsModule
  ],
  exports:[
    PageHeaderComponent,
    VideoCardComponent,
    SearchWithSelectComponent,
    AdvertismentComponent,
    VerifyCodeModalComponent
  ]
})
export class SharedModule { }
